import { AsyncThunk } from '@algoan/dashboard/store/store';
import { CashFlow, GroupedCashFlow, TransactionCategory, NotificationVariant } from '@algoan/dashboard/model';
import { recategorise } from './analysis-thunks';
import { refreshActivity } from './activity-thunks';
import { refreshFinish, refreshStart } from '@algoan/dashboard/store/slice';
import { notify } from './app-state-thunks';
import { forceTimeoutIfNeeded } from '@algoan/dashboard/utils';
import { activityMessages } from '@algoan/dashboard/store/messages';

export const modifyCategoryAndUpdateActivity =
  (
    customerId: string,
    analysisId: string,
    cashFlow: GroupedCashFlow | CashFlow,
    newCategory: TransactionCategory,
  ): AsyncThunk<void> =>
  async (dispatch) => {
    try {
      dispatch(refreshStart());
      await dispatch(recategorise(customerId, analysisId, cashFlow, newCategory));
      await dispatch(refreshActivity());
      dispatch(
        notify({
          type: NotificationVariant.SUCCESS,
          message: activityMessages.recategorisationSuccess,
        }),
      );
    } catch {
      dispatch(
        notify({
          type: NotificationVariant.ERROR,
          message: activityMessages.recategorisationError,
        }),
      );
    } finally {
      dispatch(refreshFinish());
    }
  };

export const refreshActivityPage = (): AsyncThunk => async (dispatch) => {
  try {
    dispatch(refreshStart());
    await forceTimeoutIfNeeded(dispatch(refreshActivity()), 1000);
  } finally {
    dispatch(refreshFinish());
  }
};
